export const AnalyticsEvent = {
  AuthenticationCompleted: 'authentication_completed',
};
